import { FormikProps } from "formik";
import Flex from "../../../../../../../../../../../../components/Flex";
import StyledButtonV2 from "../../../../../../../../../../../../components/app/StyledButtonV2";
import StyledFormModal from "../../../../../../../../../../../../components/globalModal/StyledModal";
import { DisclosureHost } from "../../../../../../../../../../../../hooks/use-disclosure";
import useFormDraft from "../../../../../../../../../../../../hooks/use-form-draft";
import { Form2Payload } from "../../../../../../../../../scheduling/appointment/encounter/encounter-constant";
import CheckboxCardSections from "../../InitialPsychotherapy/CheckboxCardSections";
import {
  DAP_PATIENT_RESPONSE_FIELDS,
  DAP_PATIENT_RESPONSE_SECTIONS,
} from "../DapNoteConstant";

interface PatientResponseModalProps {
  disclosureHost: DisclosureHost;
  formik: FormikProps<Form2Payload>;
}

const PatientResponseModal = ({
  disclosureHost,
  formik,
}: PatientResponseModalProps) => {
  // Edits stay in the draft until Save, so the note behind the modal is
  // untouched while the user is still filling it in — same flow as the MSE modal.
  const draft = useFormDraft(
    formik,
    DAP_PATIENT_RESPONSE_FIELDS,
    disclosureHost.opened
  );

  const handleSave = () => {
    draft.save();
    disclosureHost.close();
  };

  return (
    <StyledFormModal
      open={disclosureHost.opened}
      onClose={() => disclosureHost.close()}
      dialogTitle="Patient Response"
      dialogAction={
        <>
          <StyledButtonV2
            label="Cancel"
            variant="outlined"
            onClick={() => disclosureHost.close()}
          />
          <StyledButtonV2
            label="Save"
            variant="contained"
            onClick={handleSave}
            sx={{ width: "105px" }}
          />
        </>
      }
      sx={{
        "& .MuiDialog-paper": {
          width: "60vw",
          height: "70vh",
        },
      }}
    >
      <Flex flexDirection="column" gap={2} width="100%" height="100%" pt={2}>
        <CheckboxCardSections
          formik={draft}
          sections={DAP_PATIENT_RESPONSE_SECTIONS}
        />
      </Flex>
    </StyledFormModal>
  );
};

export default PatientResponseModal;
